import { useEffect } from 'react'
import {
  AppEmbed,
  EmbedEvent,
  HomepageModule,
  HomePageSearchBarMode,
  MessagePayload,
  Page,
} from '@thoughtspot/visual-embed-sdk'
import EmbeddedContent from '../../components/EmbeddedContent'
import { logError } from '../../services/error/logger'
import { ALL_HIDDEN_ACTIONS, COMMON_THOUGHTSPOT_ACTIONS } from '../../constants'
import { convertTsUrlToHfIntelligenceUrl } from '../../services/route/tsHfIntelligenceUrlMapper'
import { useNavigate } from 'react-router-dom'
import type { IMessagePayload } from '../../types'

export const embedId = 'embed-home'

const HomeEmbedViewConfig = {
  modularHomeExperience: true,
  pageId: Page.Home,
  hiddenHomepageModules: [HomepageModule.Learning],
  homePageSearchBarMode: HomePageSearchBarMode.AI_ANSWER,
  isUnifiedSearchExperienceEnabled: false,
  hiddenActions: ALL_HIDDEN_ACTIONS,
  ...COMMON_THOUGHTSPOT_ACTIONS,
}

/**
 * Home page accessible by the URL: /
 * This page matches the Thoughtspot 'Home' page under Insights
 *
 */

const Home = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleError = (messagePayload: MessagePayload) => {
      const embedError = new Error(`Home: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    }

    const handleRouteChange = (messagePayload: IMessagePayload) => {
      const route = messagePayload.data.currentPath
      const homeUrl = convertTsUrlToHfIntelligenceUrl(route)
      navigate(homeUrl)
    }

    const appEmbed = new AppEmbed(`#${embedId}`, HomeEmbedViewConfig)

    void appEmbed.on(EmbedEvent.Error, handleError).on(EmbedEvent.RouteChange, handleRouteChange).render()

    return () => {
      appEmbed.off(EmbedEvent.Error, handleError)
      appEmbed.off(EmbedEvent.RouteChange, handleRouteChange)
    }
  }, [navigate])

  return (
    <EmbeddedContent
      id={embedId}
      testId={embedId}
    />
  )
}

export default Home
export { HomeEmbedViewConfig }